// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { localize } from 'i18n-calypso'

// Internal Dependencies:
import Editable from 'church-theme-library/components/Editable/Editable'
// import PostSectionB from 'church-theme-library/components/PostSections/PostSectionB'
import PostTile from 'church-theme-library/components/PostTile/PostTile'
import Image from 'church-theme-library/components/Image/Image'
import ImageOverlay from 'church-theme-library/components/Image/ImageOverlay'
import { get, loop } from 'church-theme-library/utilities/objects'
import { formattedDate } from 'church-theme-library/utilities/date'

// Redux:
import { getPageData } from 'church-theme-library/redux/actions/page'

class LatestBulletin extends React.Component {
	componentDidMount() {
		const { dispatch } = this.props

		dispatch(
			getPageData( {
				type: 'bulletins',
				isArchive: true,
				slug: 'latest',
				categorySlug: '',
				number: 1,
				archivePageNumber: false,
				requestOnly: true
			} )
		)
	}

	render() {
		const { contentId, sectionId, data, translate, latestPost, postsArray, postsNumber, slugs } = this.props

		if ( ! latestPost ) {
			return null
		}

		const fullData = {
			image: data.image || {
				url: '',
				alt: '',
				aspect_ratio: '',
				focal_point: '',
				width: '',
				height: '',
				thumb: '',
				srcset: ''
			}
		}

		let className = 'section-latest-bulletin'

		if ( fullData.image.url ) {
			className += ' with-image'
		} else {
			className += ' without-image'
		}

		return (
			<div className={ className }>
				<div className="-inner">
					<div className="-content">
						<div className="-latest">
							{ latestPost &&
								<PostTile
									key={ latestPost.id }
									item={ latestPost }
									url={ latestPost.url }
									title={ translate( 'Download the latest bulletin' ) }
									date={ formattedDate( latestPost ) }
									direction="vertical"
									size="medium"
									order="image-text"
								/>
							}
						</div>
					</div>
				</div>

				<ImageOverlay imageData={ fullData.image } />

				<Editable
					id={ contentId }
					sectionId={ sectionId }
					sectionType={ data.type }
					sectionDataId="image"
					className="-image"
				>
					<Image
						thumb={ fullData.image.thumb }
						thumbWebp={ fullData.image.thumb_webp }
						url={ fullData.image.url }
						srcset={ fullData.image.srcset }
						srcsetWebp={ fullData.image.srcset_webp }
						sizes={ `(max-width: ${siteData.mobile_max_width}px) 100vw, 1100px` }
						alt={ fullData.image.alt }
						focalPoint={ fullData.image.focal_point }
						width={ fullData.image.width }
						height={ fullData.image.height }
					/>
				</Editable>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	const showPosts = 3
	const postsById = get( ['archiveCategoriesById', 'id_bulletins_latest', 'items'] )( state.page )
	let latestPost = false
	let postsArray = []
	let postsNumber = 0

	if ( postsById && Object.keys( postsById ).length ) {
		latestPost = postsById[ Object.keys( postsById )[0] ]
		postsArray = Object.keys( postsById ).slice( 1, showPosts ).map( ( key ) => {
			return postsById[ key ]
		} )
		postsNumber = Object.keys( postsById ).length
	}

	return {
		latestPost,
		postsArray,
		postsNumber,
		slugs: state.site.slugs
	}
}

export default localize(
	connect( mapStateToProps )( LatestBulletin )
)
